export default __webpack_public_path__ + "static/media/burger-bg2.449ac69e.jpg";